module.exports = __webpack_public_path__ + "img/member_list_2.f6cbe21e.png";